import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.pageYOffset > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Skills', href: '#skills' },
    { name: 'Projects', href: '#projects' },
    { name: 'Experience', href: '#experience' },
    { name: 'Contact', href: '#contact' },
  ];

  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5 }}
        className={`fixed top-0 w-full z-50 transition-all duration-300 ${
          isScrolled
            ? 'py-4 bg-[rgba(15,14,23,0.95)] shadow-[0_10px_30px_rgba(0,0,0,0.3)]'
            : 'py-6 bg-[rgba(15,14,23,0.8)]'
        } backdrop-blur-lg border-b border-[rgba(76,201,240,0.1)]`}
      >
        <div className="max-w-7xl mx-auto px-[5%] flex justify-between items-center">
          <motion.div
            className="font-display text-3xl font-black gradient-text cursor-pointer"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            PK
          </motion.div>

          {/* Desktop Menu */}
          <ul className="hidden md:flex gap-10">
            {navLinks.map((link, index) => (
              <motion.li
                key={link.name}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <a
                  href={link.href}
                  className="text-text-secondary hover:text-text-primary font-medium text-sm tracking-wider transition-colors duration-300 relative group"
                >
                  {link.name}
                  <span className="absolute bottom-[-5px] left-0 w-0 h-0.5 bg-accent-primary transition-all duration-400 group-hover:w-full"></span>
                </a>
              </motion.li>
            ))}
          </ul>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden flex flex-col gap-1.5 w-8 h-6 z-50"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <motion.span
              animate={isMobileMenuOpen ? { rotate: 45, y: 8 } : { rotate: 0, y: 0 }}
              className="w-full h-0.5 bg-accent-primary rounded-full"
            />
            <motion.span
              animate={isMobileMenuOpen ? { opacity: 0 } : { opacity: 1 }}
              className="w-full h-0.5 bg-accent-primary rounded-full"
            />
            <motion.span
              animate={isMobileMenuOpen ? { rotate: -45, y: -8 } : { rotate: 0, y: 0 }}
              className="w-full h-0.5 bg-accent-primary rounded-full"
            />
          </button>
        </div>
      </motion.nav>

      {/* Mobile Menu */}
      <motion.div
        initial={{ x: '100%' }}
        animate={{ x: isMobileMenuOpen ? 0 : '100%' }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        className="fixed top-0 right-0 h-screen w-[70%] max-w-[300px] bg-bg-secondary z-40 md:hidden shadow-[-5px_0_20px_rgba(0,0,0,0.5)]"
      >
        <ul className="flex flex-col items-center justify-center h-full gap-8">
          {navLinks.map((link) => (
            <li key={link.name}>
              <a
                href={link.href}
                onClick={handleLinkClick}
                className="text-text-secondary hover:text-text-primary font-medium text-lg tracking-wider transition-colors duration-300"
              >
                {link.name}
              </a>
            </li>
          ))}
        </ul>
      </motion.div>
    </>
  );
};

export default Navbar;
